import snackbar_store from "./store/modules/snackbar_store"
import campaign_store from "@/views/loyalty/store/modules/campaign_store"
import customer_store from "@/views/loyalty/store/modules/customer_store"
import login_store from "@/views/loyalty/store/modules/login_store"
import userProfile_store from "@/views/loyalty/store/modules/user-profile_store"

const store_loyalty = {
  snackbar_store: snackbar_store,
  campaign_store: campaign_store,
  customer_store: customer_store,
  login_store: login_store,
  userProfile_store: userProfile_store
}
export default store_loyalty
